import React from 'react';

type IconProps = {
  title?: string;
  className?: string;
  size?: number;
};

const Svg = ({
  children,
  title,
  className,
  size = 34,
}: React.PropsWithChildren<IconProps>) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    role="img"
    aria-label={title}
  >
    {title ? <title>{title}</title> : null}
    {children}
  </svg>
);

export const IconBolt = (props: IconProps) => (
  <Svg {...props} title={props.title ?? 'Bolt'}>
    <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
  </Svg>
);

export const IconCompass = (props: IconProps) => (
  <Svg {...props} title={props.title ?? 'Compass'}>
    <circle cx="12" cy="12" r="9" />
    <path d="M14.5 9.5l-2 5-5 2 2-5 5-2z" />
  </Svg>
);

export const IconTag = (props: IconProps) => (
  <Svg {...props} title={props.title ?? 'Tag'}>
    <path d="M20 10l-8.5 8.5a2.1 2.1 0 0 1-3 0L3 13V4h9l8 6z" />
    <circle cx="7.5" cy="7.5" r="1" />
  </Svg>
);
